export default () => {
    let filters = document.querySelectorAll(".--tab-filter .btn-tab");
    let projects = document.querySelectorAll(".--tab-filter .list-save-card__item");

    for (var link of filters) {
        link.addEventListener("click", filterProjects);
    }

    function filterProjects(e) {
        e.preventDefault();

        for(let eachFilter of filters) {
            eachFilter.classList.remove('_current');
        }

        let filter = this.dataset.filter;
        for(var project of projects) {
            if(filter == "all"){
            project.style.display = "initial";
            this.classList.add("_current");
            }
        else if(project.getAttribute("data-filter-item") === (filter)) {
            console.log(filter);
            project.style.display = "initial";
            this.classList.add("_current");
            }
            else {
            project.style.display = "none";
            }
        }
    }
}
